import { Directive } from 'vue'
import moment from 'moment'

// Create a global directive
const localDateDirective: Directive = {
  mounted(el, binding) {
    const date = binding.value
    const utcDate = moment.utc(date)
    const localDate = utcDate.local()
    const formattedDate = localDate.format('DD/MM/YYYY hh:mm:ss')

    el.textContent = formattedDate
  },
}

export default localDateDirective
